import React from 'react';
import { Alert } from 'react-bootstrap';
import { connect } from 'react-redux';

const NoInvoicesComponent = ({ dealerId, style }) => (
  <Alert bsStyle="warning" style={{ width: '60%', margin: 'auto', marginTop: 50, ...style }}>
    <h4>There are no invoices to display</h4>
    <p>
      We have no invoices for Dealer ID: {dealerId}. If you believe this is an error please reach
      out to your friendly PRco rep. and they will work with you to address the issue.
    </p>
  </Alert>
);

export default connect(
  ({
    auth: {
      user: {
        dealerRel: { dealerId },
      },
    },
  }) => ({
    dealerId,
  }),
)(NoInvoicesComponent);



// WEBPACK FOOTER //
// ./src/components/NoInvoices.js